import { Heading } from '@chakra-ui/react';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import React from 'react'
import CustomerConsultationMixedHandler from '../../containers/mixedHandlers/cardData/customer/consultation/CustomerConsultationMixedHandler';
import CustomerStatusHistoryMixedHandler from '../../containers/mixedHandlers/cardData/customer/history/CustomerStatusHistoryMixedHandler';

// customer consultation
// customer status history
const tabHeaders = ["Consultation client", "Historique statut client"];

const CustomerPage = () => {

    const tabContents = React.useMemo(() => (
        [
            <>
                <Heading size="md" mb={"2rem"}>Consultation Des Clients</Heading>
                <CustomerConsultationMixedHandler />
            </>,
            <>
                <Heading size="md" mb={"2rem"}>Historique des Statuts des Clients</Heading>
                <CustomerStatusHistoryMixedHandler />
            </>
        ]
    ), [CustomerConsultationMixedHandler, CustomerStatusHistoryMixedHandler]);

  return (
    <>
        <CustomTabs tabContents={tabContents} tabHeaders={tabHeaders} />
    </>
  )
}

export default CustomerPage